module.exports = __webpack_public_path__ + "img/DE.eac3de17.svg";